import { OrderStatus } from '@src/core/buyerApiClient';

export const OrderDetailsFooter = {
  UnavailableReservation: 'unavailable-reservation',
  Checkout: 'checkout',
  None: 'none',
} as const;

export type OrderDetailsFooter = (typeof OrderDetailsFooter)[keyof typeof OrderDetailsFooter];

export function resolveOrderDetailsFooter(status: OrderStatus): OrderDetailsFooter {
  switch (status) {
    case OrderStatus.Created:
    case OrderStatus.AwaitingConfirmation:
      return OrderDetailsFooter.Checkout;
    case OrderStatus.Confirmed:
      return OrderDetailsFooter.None;
    case OrderStatus.Expired:
    case OrderStatus.PaymentVoided:
    case OrderStatus.PaymentChargedBack:
    case OrderStatus.Canceled:
      return OrderDetailsFooter.UnavailableReservation;
  }
}
